import { Component, Input, OnInit } from '@angular/core';
import { BinLocationModel } from 'src/app/models/bin-location.model';
import { DocumentModel } from 'src/app/models/document.model';
import {ModalController} from '@ionic/angular';
import { SelectBinLocationPage } from 'src/app/modals/select-bin-location/select-bin-location.page';

@Component({
  selector: 'bin-location',
  templateUrl: './bin-location.component.html',
  styleUrls: ['./bin-location.component.scss'],
})
export class BinLocationComponent implements OnInit {

  @Input() document: DocumentModel;

  constructor(private modalController: ModalController,
              ) {
  }

  ngOnInit() {
      if (!this.document.serviceJob.binLocation) {
        this.document.serviceJob.binLocation = new BinLocationModel();
      }
  }

  async openModalSearch() {
      const modal = await this.modalController.create({
          component: SelectBinLocationPage,
          cssClass: 'modal-fullscreen',
          componentProps: {
              'document': this.document
          }
      });

      modal.onDidDismiss().then((dataReturned) => {
          console.log( dataReturned );
          if (dataReturned.data) {
              this.document.serviceJob.binLocation = dataReturned.data;

              console.log( this.document.serviceJob.binLocation );
          }
      });
      return await modal.present();

  }

}
